<template>
    <div>
        <validation-observer ref="toggleForm">
            <div class="form-group p-0-14">
                <label class="attribute-label">
                    {{ attribute.attribute_name }}
                    <a v-if="removeTags(attribute.extra_info) !== ''" :data-content="popover_custom_data(attribute.extra_info)"
                       data-html="true" data-placement="bottom"
                       data-toggle="popover"
                       href="javascript:;"> <i class="fa fa-info-circle"></i></a>
                </label>
                <div class="toggle-attribute">
                    <label class="figma-switch">
                        <input id="toggle-attribute" :checked="selected.attribute_value === 'Yes'? 1 : 0"
                               :class="{'selected':selected.attribute_value === 'Yes'}"
                               type="checkbox"
                               @click="changeToggleValue(selected.attribute_value === 'Yes'? 1 : 0)">
                        <span class="slider round" for="toggle-attribute"> </span>
                    </label>
                    <span  class="cost-attribute"   style="text-align: left;">
                             <span  class="unit_priceunit_price"  v-if="attribute.unit_price && parseFloat(attribute.unit_price) > 0" >
                                       +{{ priceText(attribute.unit_price, attribute.cost_type,currency,unit) }}
                             </span>
                             <span  class="attribute_additional_timeData" v-if="attribute.attribute_additional_time">
                               {{ callAdditionalTimeTextData(attribute.attribute_additional_time )    }}
                             </span>
                    </span>
                </div>
                <validation-provider v-slot="{errors}" :rules="attribute.mandatory ? 'required' : ''">
                    <div v-if="selected && selected.hasOwnProperty('attribute_value_id')" class="display-none">
                        <input :id="id" :name="name" :value="selected.attribute_value === 'Yes'? 1 : 0"
                               type="hidden">
                    </div>
                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </validation-observer>
        <div v-if="dependency.length > 0" class="form-group p-0-14">
            <div v-for="(dependent,index) of dependency" v-if="selected" :key="dependent.attribute_id">
                 <attribute v-model="dependency[index]"
                           :attributes="attributes"
                           :clone="clone"
                           :currency="currency"
                           :date-format="dateFormat"
                           :time-format="timeFormat"
                           :unit="unit">

                </attribute>
            </div>
        </div>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {priceText} from "@/events/sharedMethods.js";

export default {
    name: "ToggleAttribute",
    props: {
        attributes: {
            type: Array,
            default() {
                return []
            }
        },
        attribute: {
            type: Object,
            required: true
        },
        currency: {
            required: true
        },
        unit: {
            required: true
        },
        value: {
            default() {
                return null
            }
        },
        dateFormat: null,
        timeFormat: null,
        clone: 0
        ,
        additionalTimeTextData:Function
    },
    data() {
        return {
            selected: this.value
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        /**
         * gets all dependencies of the selected attribute
         * @returns {T[]|*[]}
         */
        dependency() {
            if (this.selected && this.selected.dependency) {
                return this.attributes.filter(attribute => this.selected.dependency.includes(attribute.attribute_id))
            }
            return []
        },
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
            // return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
        }
    },
    methods: {
        priceText,
        callAdditionalTimeTextData(val){
            return  this.additionalTimeTextData(val);
        }
        ,

        addEventListeners() {


            EventBus.$on('onServiceAttributesValidation', async (verify) => {
                let validated = await this.$refs.toggleForm.validate();
                if (!validated) {
                    /** If there is a validation error then show the validation and open collapsed services  **/
                    EventBus.$emit('onCollapseService', this.attribute)

                }
                verify(validated)
            })


        },
        /**
         * pick a value
         * @param value
         */
        changeToggleValue(value) {
            if (value) {
                this.attribute.attribute_values.forEach((attribute_value_object) => {
                    if (attribute_value_object.attribute_value === "No") {
                        attribute_value_object.unit_price = 0;
                        attribute_value_object.cost_type = this.attribute.cost_type;
                        attribute_value_object.additional_time = 0;
                        this.selected = attribute_value_object
                    }
                });
            } else {
                this.attribute.attribute_values.forEach((attribute_value_object) => {
                    if (attribute_value_object.attribute_value === "Yes") {
                        attribute_value_object.unit_price = this.attribute.unit_price;
                        attribute_value_object.cost_type = this.attribute.cost_type;
                        attribute_value_object.additional_time = this.attribute.attribute_additional_time;
                        this.selected = attribute_value_object;
                    }
                });
            }
            this.attribute.selected = this.selected;
            this.$emit('input', value);
            EventBus.$emit('onServiceCustomFieldSelected', this.attribute.service_id, this.clone)
        },

        removeObjectWithId(arr, id) {
            const found = arr.filter(element => element.attribute_id == id);
            const count = arr.filter(element => element.attribute_id == id).length;
            arr.splice(found, count);
        },
        removeTags(value) {
            const div = document.createElement('div');
            div.innerHTML = value;
            var DataToAdd=null
            if(div.textContent){
                DataToAdd= div.textContent
            }
            else if(div.innerText){
                DataToAdd= div.innerText
            }else{   DataToAdd= '';  }
            if(DataToAdd){
                return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${DataToAdd}</div>`;
            }else {
                return DataToAdd;
            }            },
        popover_custom_data(value) {
            return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${value}</div>`;;
        },
    },
    mounted() {
        this.addEventListeners();

        if (this.clone < 1)
            this.changeToggleValue(this.value - 1)
    },
    watch: {
        selected: {
            handler(selected) {
                this.$emit('input', selected)
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.selected {
    font-weight: bold;
}
</style>